var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{style:({background: _vm.background}),attrs:{"id":"textree-mobile-more","href":"#"},on:{"click":_vm.trigger}},[_c('img',{attrs:{"src":_vm.arrow,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }